import React, {useEffect} from 'react';
import {postAuditEntry} from "../common/common";
import Title from "../components/title";
import Enquiry from "../components/enquiry";
import MetaTag from "../components/metatag";
import '../../scss/pages/contactus.scss';
import {useIndex} from "../common/hook";
import {getSessionCookie} from "../common/session";

const pagetitle = 'Contact Us';
const source = 'contact-us';

function ContactUs(props) {
    const index = useIndex(window.location.hostname, window.location.protocol);
    const ddhomeCountry = getSessionCookie('ddhomeCountry');

    useEffect(() => {
        postAuditEntry(
            {
                date: new Date(),
                countryCode: ddhomeCountry.country_code,
                hostName: window.location.hostname,
                ipAddress: ddhomeCountry.ip_address,
                page: 'contact us',
                message: 'Contact Us Page Accessed'
            }
        );
    }, []);

    return (
        <>
            <MetaTag page={source} index={index} url={window.location.protocol + '//'  + window.location.hostname} />
            <div className="boxouter">
                <div className="container">
                    <div className="contactusframe">
                        <Title message={pagetitle} />
                        <div className="contactuscontainer">
                            <div className="fieldcontainer">
                                <p className="contactus"><label>Want to get in touch?</label></p>
                                <p className="contactus"><label>Please use the form below or you can email us at <a href="mailto:helpdesk@heritagebank.com" target="blank">helpdesk@heritagebank.com</a></label></p>
                            </div>
                        </div>
                        <Enquiry type="GEQ" source={source} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default ContactUs;